(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/draws/assets/javascripts/services/fetch-single-race-draw.js') >= 0) return;  svs.modules.push('/components/marketplace-data/draws/assets/javascripts/services/fetch-single-race-draw.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  cachedJupiterGet
} = svs.components.marketplaceData;
const {
  helpers
} = svs.components.marketplaceData.draws;
const {
  services
} = svs.components.marketplaceData.draws;
const fetchSingleRaceDraw = (productId, drawNumber, callback) => {
  const url = "/racing/1/race/draw/".concat(drawNumber);
  fetchSingleRaceDraw.cacheRequest(url, response => {
    const normalizedRace = helpers.normalizeRaceMarketplace(response);
    const draw = normalizedRace.draws.find(draw => draw.drawNumber === drawNumber);
    if (!draw) {
      return callback(new Error("Kunde inte hitta omg\xE5ngen ".concat(drawNumber)));
    }
    services.fetchRacingTurnover(draw.raceId, draw.userProduct, (error, netSale) => {
      if (error) {
        draw.currentNetSale = null;
      } else {
        draw.currentNetSale = netSale.turnover;
        draw.jackpot = netSale.jackpot;
      }
      callback(undefined, _objectSpread(_objectSpread({}, normalizedRace), {}, {
        draws: [draw]
      }));
    });
  }, error => callback(error.responseJSON.error));
};
fetchSingleRaceDraw.cacheRequest = cachedJupiterGet.createCache(3000);
setGlobal('svs.components.marketplaceData.draws.services.fetchSingleRaceDraw', fetchSingleRaceDraw);

 })(window);